module.exports = "/images/vendor/flag-icon-css/flags/4x3/ua.svg?a8b13525ee3b82f901196668f4733097";